module.exports = {"431081001":"唐洞街道","431081002":"东江街道","431081100":"滁口镇","431081102":"三都镇","431081103":"蓼江镇","431081105":"兴宁镇","431081106":"州门司镇","431081108":"黄草镇","431081110":"汤溪镇","431081112":"清江镇","431081113":"白廊镇","431081219":"回龙山瑶族乡","431081220":"八面山瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431081.json
// module id = 1737
// module chunks = 0